import React, { PureComponent } from 'react';
import { I } from '../../../common/v5/config';

export default class PttWidgetPreview extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isPlaying: false,
      playbackTime: 0
    };
    this.playbackInterval = null;
  }

  componentWillUnmount() {
    if (this.playbackInterval) {
      clearInterval(this.playbackInterval);
    }
  }

  getConfig = (config, defaultConfig) => {
    const { input } = this.props;
    const value = input[config];
    
    // Return default if value is undefined, null, or empty string
    if (value === undefined || value === null || value === '') {
      return defaultConfig;
    }
    
    return value;
  };

  formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  handleStartPlayback = () => {
    this.setState({ isPlaying: true, playbackTime: 0 });
    this.playbackInterval = setInterval(() => {
      this.setState(prevState => ({
        playbackTime: prevState.playbackTime + 1
      }));
    }, 1000);
  };

  handleStopPlayback = () => {
    this.setState({ isPlaying: false });
    if (this.playbackInterval) {
      clearInterval(this.playbackInterval);
      this.playbackInterval = null;
    }
  };

  renderCode = () => {
    const { input } = this.props;
    
    const widgetId = input.widgetId || 'your_widget_id';
    const sipQueueId = input.sipQueueId || 'your_sip_queue_id';
    const voiceUrl = input.voiceUrl || 'voice1.cention.com';
    const buttonText = input.buttonText || 'Push to Talk';
    const buttonColor = input.buttonColor || 'blue';
    const buttonSize = input.buttonSize || 'medium';

    let code = `<body>\n`;
    code += `    <div class="container">\n`;
    code += `        <div id="pushToTalkContainer"></div>\n`;
    code += `        <audio id="CentionCallAudio"\n`;
    code += `            hidden={true}\n`;
    code += `            loop={true}\n`;
    code += `            autoPlay\n`;
    code += `        />\n`;
    code += `    </div>\n\n`;
    code += `    <script src="https://static.cention.com/sg/chat/js/ppt-widget.js" type="text/javascript"></script>\n\n`;
    code += `    <script>\n`;
    code += `        // Example configuration\n`;
    code += `        const widgetId = '${widgetId}';\n`;
    code += `        const workspaceName = 'cention';\n`;
    code += `        \n`;
    code += `        // Global variables that PushToTalk depends on\n`;
    code += `        window.CentionApidURL = 'https://apid.cention.com';\n`;
    code += `        window.CentionVoiceURL = '${voiceUrl}';\n`;
    code += `        window.CentionVoiceQueue = '${sipQueueId}';\n\n`;
    code += `        // Create PushToTalk instance\n`;
    code += `        const pushToTalk = new PushToTalk(widgetId, workspaceName, '${buttonText}', '${buttonColor}');\n`;
    code += `        \n`;
    code += `        // Add the button to the container\n`;
    code += `        document.getElementById('pushToTalkContainer').appendChild(pushToTalk.getButton());\n`;
    code += `        \n`;
    code += `        // Example of how to handle cleanup when the page is unloaded\n`;
    code += `        window.addEventListener('beforeunload', async () => {\n`;
    code += `            await pushToTalk.destroy();\n`;
    code += `        });\n`;
    code += `    </script>\n`;
    code += `</body>`;

    return code;
  };

  render() {
    const { input } = this.props;
    const { isPlaying, playbackTime } = this.state;

    const buttonText = this.getConfig("buttonText", "Push to Talk");
    const buttonColor = this.getConfig("buttonColor", "blue");
    const buttonSize = this.getConfig("buttonSize", "medium");

    // Convert color name to hex if needed
    const getColorValue = (color) => {
      if (color === "blue") return "#007bff";
      if (color === "red") return "#dc3545";
      if (color === "green") return "#28a745";
      if (color === "yellow") return "#ffc107";
      if (color === "orange") return "#fd7e14";
      if (color === "purple") return "#6f42c1";
      if (color === "pink") return "#e83e8c";
      if (color === "gray" || color === "grey") return "#6c757d";
      if (color === "black") return "#000000";
      if (color === "white") return "#ffffff";
      // If it's already a hex value or other valid CSS color, return as is
      return color;
    };

    return (
      <div className="ptt-widget-preview">
        <div className="preview-container">
          {/* Widget Title */}
          {input.title && (
            <div className="widget-title">
              {input.title}
            </div>
          )}

          {/* Widget Description */}
          {input.description && (
            <div className="widget-description">
              {input.description}
            </div>
          )}

          {/* Main Push to Talk Button */}
          <div className="ptt-button-container">
            <button
              className={`ptt-button ${buttonSize}`}
              style={{
                backgroundColor: getColorValue(buttonColor)
              }}
            >
              {buttonText}
            </button>
          </div>
        </div>
      </div>
    );
  }
} 